// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M10.25 3H11C12.1 3 13 3.9 13 5V12.25C13 13.35 12.1 14.25 11 14.25H5C3.9 14.25 3 13.35 3 12.25V5C3 3.9 3.9 3 5 3H5.75',
  'M6.5 1.75H9.5C9.91 1.75 10.25 2.09 10.25 2.5V3.25C10.25 3.66 9.91 4 9.5 4H6.5C6.09 4 5.75 3.66 5.75 3.25V2.5C5.75 2.09 6.09 1.75 6.5 1.75Z',
  'M5.62 7.5C7.99 6.31 8.01 8.88 10.41 7.5M5.62 11C7.99 9.81 8.01 12.38 10.41 11',
];
